import { Phone, MessageCircle, ArrowUpRight, Clock, ShieldCheck, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
const NAVY = "#081438";
const NAVY_DEEP = "#050D24";
const NAVY_LIGHT = "#243752";
const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
const TRUST_POINTS = [{
  Icon: Clock,
  label: "Same-day service",
  sub: "Avg. 22min response"
}, {
  Icon: ShieldCheck,
  label: "12-month warranty",
  sub: "Workmanship + parts"
}, {
  Icon: MapPin,
  label: "Sydney-wide",
  sub: "150+ suburbs covered"
}];
export default function RollerCTA() {
  return <section style={{
    background: NAVY_DEEP,
    position: "relative",
    overflow: "hidden",
    padding: "120px 24px",
    fontFamily: FONT_BODY
  }}>
      {/* Atmospheric layers */}
      <div aria-hidden style={{
      position: "absolute",
      inset: 0,
      background: `radial-gradient(circle at 30% 20%, rgba(245,166,35,0.12) 0%, transparent 50%), radial-gradient(circle at 80% 100%, rgba(245,166,35,0.06) 0%, transparent 50%)`,
      pointerEvents: "none"
    }} />

      {/* Grain */}
      <div aria-hidden style={{
      position: "absolute",
      inset: 0,
      opacity: 0.04,
      mixBlendMode: "overlay",
      pointerEvents: "none",
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100' height='100'%3E%3Cfilter id='n'%3E%3CfeTurbulence baseFrequency='0.9'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='0.5'/%3E%3C/svg%3E\")"
    }} />

      {/* Massive watermark */}
      <div aria-hidden style={{
      position: "absolute",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      fontFamily: FONT_HEAD,
      fontSize: "clamp(200px, 28vw, 400px)",
      fontWeight: 900,
      color: "rgba(255,255,255,0.015)",
      letterSpacing: "-0.04em",
      lineHeight: 1,
      pointerEvents: "none",
      userSelect: "none",
      zIndex: 1,
      whiteSpace: "nowrap"
    }}>
        GOLD
      </div>

      <div style={{
      position: "relative",
      zIndex: 2,
      maxWidth: 1200,
      margin: "0 auto"
    }}>
        {/* === EYEBROW === */}
        <div style={{
        display: "flex",
        justifyContent: "center",
        marginBottom: 32
      }}>
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 12
        }}>
            <span style={{
            width: 32,
            height: 1,
            background: GOLD
          }} />
            <span style={{
            fontFamily: FONT_BODY,
            fontSize: 11,
            fontWeight: 800,
            letterSpacing: "0.25em",
            textTransform: "uppercase",
            color: GOLD
          }}>
              09 / Ready when you are
            </span>
            <span style={{
            width: 32,
            height: 1,
            background: GOLD
          }} />
          </div>
        </div>

        {/* === MAIN HEADLINE === */}
        <h2 style={{
        fontFamily: FONT_HEAD,
        fontSize: "clamp(42px, 6vw, 80px)",
        fontWeight: 800,
        color: "#ffffff",
        lineHeight: 0.98,
        letterSpacing: "-0.035em",
        margin: "0 0 28px",
        textAlign: "center",
        maxWidth: 1000,
        marginLeft: "auto",
        marginRight: "auto"
      }}>
          Your roller door
          <br />
          <span style={{
          background: `linear-gradient(135deg, ${GOLD} 0%, #D4A63A 100%)`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          backgroundClip: "text",
          display: "inline-block",
          fontStyle: "italic"
        }}>
            fixed today.
          </span>
        </h2>

        <p style={{
        fontFamily: FONT_BODY,
        fontSize: "clamp(17px, 1.6vw, 21px)",
        color: "rgba(255,255,255,0.75)",
        lineHeight: 1.55,
        textAlign: "center",
        maxWidth: 640,
        margin: "0 auto 56px"
      }}>
          Call now for a free phone diagnosis. Most repairs sorted same day with
          parts already in the van.
        </p>

        {/* === BIG CTA BUTTONS === */}
        <div style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: 16,
        marginBottom: 72
      }}>
          {/* Primary — Call */}
          <a href="tel:0485000933" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 14,
          padding: "22px 36px",
          background: `linear-gradient(135deg, ${GOLD} 0%, #D4A63A 100%)`,
          color: NAVY,
          fontFamily: FONT_HEAD,
          fontSize: 18,
          fontWeight: 800,
          borderRadius: 12,
          textDecoration: "none",
          transition: "transform 0.2s, box-shadow 0.2s",
          boxShadow: "0 12px 36px rgba(245,166,35,0.4)",
          letterSpacing: "-0.005em"
        }} onMouseEnter={e => {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = "0 18px 48px rgba(245,166,35,0.55)";
        }} onMouseLeave={e => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 12px 36px rgba(245,166,35,0.4)";
        }}>
            <Phone size={22} strokeWidth={2.5} />
            <span>Call 0485 000 933</span>
          </a>

          {/* Secondary — WhatsApp */}
          <a href="https://wa.me/61485000933?text=Hi%20Gold%20Garage%20Door%2C%20I%20need%20help%20with%20my%20roller%20door." target="_blank" rel="noopener noreferrer" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 14,
          padding: "22px 36px",
          background: "#25D366",
          color: NAVY,
          fontFamily: FONT_HEAD,
          fontSize: 18,
          fontWeight: 800,
          borderRadius: 12,
          textDecoration: "none",
          transition: "transform 0.2s, box-shadow 0.2s",
          boxShadow: "0 12px 36px rgba(37,211,102,0.35)",
          letterSpacing: "-0.005em"
        }} onMouseEnter={e => {
          e.currentTarget.style.transform = "translateY(-3px)";
          e.currentTarget.style.boxShadow = "0 18px 48px rgba(37,211,102,0.5)";
        }} onMouseLeave={e => {
          e.currentTarget.style.transform = "translateY(0)";
          e.currentTarget.style.boxShadow = "0 12px 36px rgba(37,211,102,0.35)";
        }}>
            <MessageCircle size={22} strokeWidth={2.5} />
            <span>WhatsApp Us</span>
          </a>

          {/* Tertiary — Form */}
          <Link to="#contact-us" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: 10,
          padding: "22px 32px",
          background: "transparent",
          color: "#ffffff",
          fontFamily: FONT_HEAD,
          fontSize: 17,
          fontWeight: 600,
          borderRadius: 12,
          textDecoration: "none",
          border: "1px solid rgba(255,255,255,0.3)",
          transition: "background 0.2s, border-color 0.2s"
        }} onMouseEnter={e => {
          (e.currentTarget as HTMLAnchorElement).style.background = "rgba(255,255,255,0.08)";
          (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.6)";
        }} onMouseLeave={e => {
          (e.currentTarget as HTMLAnchorElement).style.background = "transparent";
          (e.currentTarget as HTMLAnchorElement).style.borderColor = "rgba(255,255,255,0.3)";
        }}>
            Free quote form
            <ArrowUpRight size={16} strokeWidth={2.5} />
          </Link>
        </div>

        {/* === TRUST POINTS ROW === */}
        <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 0,
        background: "rgba(255,255,255,0.025)",
        border: "1px solid rgba(255,255,255,0.08)",
        borderRadius: 4,
        overflow: "hidden"
      }} className="roller-cta-trust">
          {TRUST_POINTS.map((point, i) => {
          const Icon = point.Icon;
          return <div key={i} style={{
            padding: "32px 28px",
            borderRight: i === TRUST_POINTS.length - 1 ? "none" : "1px solid rgba(255,255,255,0.06)",
            display: "flex",
            alignItems: "center",
            gap: 18
          }}>
                <div style={{
              width: 48,
              height: 48,
              borderRadius: 10,
              background: "rgba(245,166,35,0.12)",
              border: "1px solid rgba(245,166,35,0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0
            }}>
                  <Icon size={22} color={GOLD} strokeWidth={1.8} />
                </div>
                <div>
                  <div style={{
                fontFamily: FONT_HEAD,
                fontSize: 16,
                fontWeight: 700,
                color: "#ffffff",
                lineHeight: 1.2,
                letterSpacing: "-0.005em",
                marginBottom: 4
              }}>
                    {point.label}
                  </div>
                  <div style={{
                fontFamily: FONT_BODY,
                fontSize: 12,
                color: "rgba(255,255,255,0.55)",
                letterSpacing: "0.02em"
              }}>
                    {point.sub}
                  </div>
                </div>
              </div>;
        })}
        </div>

        {/* === SIGNATURE FOOTER LINE === */}
        <div style={{
        marginTop: 72,
        paddingTop: 32,
        borderTop: "1px solid rgba(255,255,255,0.08)",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        gap: 16
      }}>
          <div style={{
          fontFamily: FONT_BODY,
          fontSize: 13,
          color: "rgba(255,255,255,0.55)",
          letterSpacing: "0.01em"
        }}>
            Gold Garage Door · Bass Hill · Sydney-wide service since 2009
          </div>

          <div style={{
          display: "flex",
          gap: 20,
          fontFamily: FONT_BODY,
          fontSize: 12,
          color: "rgba(255,255,255,0.45)",
          fontWeight: 600,
          letterSpacing: "0.05em",
          textTransform: "uppercase"
        }}>
            <span style={{
            color: GOLD
          }}>★ ★ ★ ★ ★</span>
            <span>5.0 Google Rating</span>
            <span>·</span>
            <span>100+ Reviews</span>
          </div>
        </div>
      </div>

      {/* Responsive */}
      <style>{`
        @media (max-width: 900px) {
          .roller-cta-trust {
            grid-template-columns: 1fr !important;
          }
          .roller-cta-trust > div {
            border-right: none !important;
            border-bottom: 1px solid rgba(255,255,255,0.06) !important;
          }
          .roller-cta-trust > div:last-child {
            border-bottom: none !important;
          }
        }
      `}</style>
    </section>;
}